import React, { useState, useEffect } from "react";

import { isMobileOnly } from 'react-device-detect';


import DateUtil from "../../common/dateUtil";

import ErrorComp from "../common/ErrorComp";
import LoadingComp from "../common/LoadingComp";

import PreTradeSearchCriteriaComp from "./PreTradeSearchCriteriaComp";
import PreTradeGridComp from "./PreTradeGridComp";
import PreTradeListComp from "./PreTradeListComp";

import PreTradeDetailComp from "./PreTradeDetailComp";

import { fetchCall } from "../../common/FetchHelpers";


const PreTradeSearchComp = (props) => {


    const searchUrl = "api/trade-request/search";
    const detailUrl = "api/trade-request/details/";

    let initFromDate = new Date(new Date());
    initFromDate.setDate(initFromDate.getDate() - 90);

    const fromDateStr = DateUtil.toIsoStrDate(initFromDate);

    const initFormData = {
        securitySymbol: "",
        securityDesc: "",
        brokerDealerId: [""],
        tradeActions: "B,S,SS",
        account: "",
        fromDate: fromDateStr,
        toDate: DateUtil.toIsoStrDate(new Date()),
        reqStatus: "APPROVED,PENDING,REJECTED",
        securityTypes: "Equity,Bond,Option,MutualFund,Alternative",
    };

    const [reloadResult, setReloadResult] = useState(false);
    const [searchCriteria, setSearchCriteria] = useState(initFormData);

    const [showError, setShowError] = useState(false);
    const [loading, setLoading] = useState(false);
    const [showResult, setShowResult] = useState(false);
    const [showDetail, setShowDetail] = useState(false);

    const [items, setItems] = useState([]);
    const [currentItem, setCurrentItem] = useState({});


    const [dataFrame, setDataFrame] = useState({ startIndex: 0, limit: 10 });


    const searchItems = (jsonData) => {
        setLoading(true);

        setSearchCriteria(jsonData);


        const fetchConfig = {
            method: "POST",
            cache: "no-cache",
            headers: {
                "Content-Type": "application/json"
            },
            redirect: "follow",
            referrerPolicy: "no-referrer",
            body: JSON.stringify(jsonData),
        };

        fetchCall(searchUrl, fetchConfig)
            .then((result) => {
                setDataFrame({ startIndex: 0, limit: 10 });
                setItems(result);
                setLoading(false);
                setShowResult(true);
                setReloadResult(false);
            },
                (err) => {
                    setLoading(false);
                    setShowError(true);
                }
            );
    };

    const onSearch = (data) => {
        setShowResult(false);
        searchItems(data);
    };

    const detailClickHandler = (id) => {
        setShowResult(false);
        setLoading(true);
        const url = detailUrl + id;

        fetchCall(url)
            .then((result) => {
                setLoading(false);
                result.formData = JSON.parse(result.formData);
                if(result.templateStr){
                    result.template = {};
                    result.template.templateStr = result.templateStr;
                }    
                result.isPassiveInvestor = result.passiveInvolvement ? "Yes" : "No";
                result.isClientInvolve = result.clientInvolvement ? "Yes" : "No";
                result.isPublicBusiness = result.publicTradeEntity ? "Yes" : "No";
                result.isBusinessCustody = result.businessCustody ? "Yes" : "No";
                result.isCapitalRaise = result.capitalRaiseDesc ? "Yes" : "No";
                result.isOwnershipBeneficial = result.isOwnershipBeneficial ? "Yes" : "No";
                if (result.attachments) {
                    result.attachments = result.attachments.map(x => (
                        {
                            ...x,
                            name: x.fileName,
                            type: x.mimeType
                        })
                    );
                }
                setCurrentItem(result);

                setShowDetail(true);

            },
                (err) => {
                    setLoading(false);
                    setShowError(true);
                }
            );
    };

    const handleReloadItem = (id) => {
        const url = detailUrl + id;

        fetchCall(url)
            .then((result) => {
                if(result.templateStr){
                    result.template = {};
                    result.template.templateStr = result.templateStr;
                }    

                setCurrentItem(result);
                setReloadResult(true);
            },
                (err) => {
                    console.log(err);
                }
            );
    };

    const handleCloseDetail = () => {
        setShowDetail(false);

        if (reloadResult) {
            onSearch(searchCriteria);
        } else {
            setShowResult(true);
        }

    };

    useEffect(() => {
        searchItems(initFormData);
    }, []);

    return (
        <div>
            {!showDetail && (
                <PreTradeSearchCriteriaComp
                    onSearch={onSearch}
                    metadata={props.metadata}
                />
            )}

            {showError && <ErrorComp />}
            {loading && <LoadingComp />}
            {showResult && (
                <div>
                    {
                        isMobileOnly && <PreTradeListComp items={items} dataFrame={dataFrame} setDataFrame={setDataFrame} onDetail={detailClickHandler} />
                    }
                    {
                        !isMobileOnly && <PreTradeGridComp items={items} dataFrame={dataFrame} setDataFrame={setDataFrame} onDetail={detailClickHandler} />
                    }

                </div>
            )}
            {showDetail && (
                <PreTradeDetailComp
                    data={currentItem}
                    title="Details"
                    metadata={props.metadata}
                    reloadItem={handleReloadItem}
                    handleUpdate={p => props.handleUpdate(currentItem)}
                    handleClose={handleCloseDetail}
                />
            )}
        </div>
    );
};

export default PreTradeSearchComp;
